<template>
  <div class="container page">
    <van-nav-bar :title="$t('comments.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main" v-if="list.length > 0">
      <!-- 顶部人物展示 -->
      <div class="cover-stage" v-if="top3.length > 0">
        <div class="stage-overlay"></div>
        <div class="stage-title">{{ $t('comments.top_title') }}</div>

        <!-- 三图容器 -->
        <div class="images-container">
          <div
            v-for="item in imageItems"
            :key="item.idx"
            :class="['stage-photo', 'position-' + item.position]"
            :style="{ backgroundImage: 'url(' + top3[item.idx].icon + ')' }"
          >
            <div class="photo-rank-badge">{{ ['👑','🥈','🥉'][item.idx] }}</div>
          </div>
        </div>
      </div>

      <!-- 评论列表 -->
      <div class="list-section">
        <div class="list-title">{{ $t('comments.rank_title') }}</div>
        <div
          v-for="item in list"
          :key="item.id"
          class="comment-item"
        >
          <!-- 左侧：头像，暂时隐藏，后续如需恢复可直接取消注释
          <div class="comment-left">
            <div class="avatar-wrap" :class="index < 3 ? 'avatar-top' + (index + 1) : ''">
              <img :src="item.icon" class="comment-avatar" @error="$event.target.src='/img/error.png'" />
            </div>
          </div>
          -->
          <!-- 右侧：全部内容 -->
          <div class="comment-body">
            <div class="comment-user-row">
              <div class="comment-user-info">
                <span class="comment-name">{{ item.nickname }}</span>
                <!-- 时间，暂时隐藏，后续如需恢复可直接取消注释
                <span v-if="item.create_time" class="comment-time">{{ formatDate(item.create_time) }}</span>
                -->
              </div>
              <span class="comment-likes">
                <van-icon name="good-job-o" color="#ff6034" />
                {{ item.display_likes }}
              </span>
            </div>
            <div
              class="comment-text"
              :class="{ 'comment-text--expanded': item._expanded }"
            >{{ item.content }}</div>
            <div
              v-if="item.content && item.content.length > 40"
              class="comment-expand"
              @click="toggleExpand(item)"
            >{{ item._expanded ? $t('comments.collapse') : $t('comments.expand') }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-empty v-else-if="!loading" :description="$t('comments.empty')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: true,
      imageItems: [
        { idx: 0, position: 0 },
        { idx: 1, position: 1 },
        { idx: 2, position: 2 }
      ],
      rotateTimer: null,
      pollTimer: null
    };
  },
  computed: {
    top3() {
      return this.list.slice(0, 3);
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    formatDate(val) {
      if (!val) return '';
      const d = new Date(val * 1000);
      if (isNaN(d.getTime())) return '';
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      const s = String(d.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${day} ${h}:${min}:${s}`;
    },
    getCommentsList() {
      this.$http({
        method: 'get',
        url: 'comments_list'
      }).then(res => {
        this.loading = false;
        if (res.code === 200) {
          this.list = res.data.map(item => ({ ...item, _expanded: false }));
          this.imageItems = [{ idx: 0, position: 0 }, { idx: 1, position: 1 }, { idx: 2, position: 2 }];
          this.startRotation();
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    startRotation() {
      if (this.rotateTimer) clearInterval(this.rotateTimer);
      if (this.top3.length < 2) return;
      this.rotateTimer = setInterval(() => {
        this.imageItems = this.imageItems.map(item => ({
          ...item,
          position: (item.position + 1) % 3
        }));
      }, 4000);
    },
    startPolling() {
      this.pollTimer = setInterval(() => {
        this.getCommentsList();
      }, 30000);
    },
    toggleExpand(item) {
      this.$set(item, '_expanded', !item._expanded);
    }
  },
  created() {
    this.loading = true;
    this.getCommentsList();
    this.startPolling();
  },
  beforeDestroy() {
    if (this.rotateTimer) clearInterval(this.rotateTimer);
    if (this.pollTimer)   clearInterval(this.pollTimer);
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.container .main {
  background-color: #f2f2f5;
  min-height: calc(100% - 50px);
  padding-bottom: 30px;
}

/* ===== 封面展示区 ===== */
.cover-stage {
  position: relative;
  width: 100%;
  height: 420px;
  overflow: hidden;
  background: #fff;
}

/* 顶部标题 */
.stage-title {
  position: absolute;
  top: 18px;
  left: 28px;
  z-index: 3;
  color: #333;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 2px;
}

/* overlay 不需要了，置空 */
.stage-overlay { display: none; }

/* 三图容器 */
.images-container {
  position: absolute;
  inset: 0;
  z-index: 2;
}

/* 每张照片：统一基础尺寸，用 scale 区分大小 */
.stage-photo {
  position: absolute;
  width: 34%;
  aspect-ratio: 3 / 4;
  background-size: cover;
  background-position: center top;
  border-radius: 16px;
  overflow: hidden;
  /* 同时过渡位置、缩放、透明度、阴影 */
  transition:
    left 1.3s cubic-bezier(0.4, 0, 0.2, 1),
    top  1.3s cubic-bezier(0.4, 0, 0.2, 1),
    transform 1.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity   1.3s ease,
    box-shadow 1.3s ease,
    z-index 0s;
}

/* 排名徽章 */
.photo-rank-badge {
  position: absolute;
  top: 8px;
  left: 10px;
  font-size: 26px;
  line-height: 1;
  filter: drop-shadow(0 1px 4px rgba(0,0,0,0.5));
}

/* 位置0：左侧，缩小 */
.position-0 {
  top: 54%;
  left: 4%;
  transform: translateY(-50%) scale(0.76);
  transform-origin: center center;
  opacity: 0.7;
  z-index: 1;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

/* 位置1：中间，放大突出 */
.position-1 {
  top: 54%;
  left: 33%;
  transform: translateY(-50%) scale(1.15);
  transform-origin: center center;
  opacity: 1;
  z-index: 3;
  box-shadow: 0 12px 36px rgba(196,113,160,0.35);
}

/* 位置2：右侧，缩小 */
.position-2 {
  top: 54%;
  left: 62%;
  transform: translateY(-50%) scale(0.76);
  transform-origin: center center;
  opacity: 0.7;
  z-index: 2;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

/* ===== 列表区 ===== */
.list-section {
  padding: 20px 20px 0;
}

.list-title {
  font-size: 30px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 6px solid #7e5678;
}

.comment-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  margin-bottom: 16px;
  gap: 16px;
}

/* 左侧头像样式保留，当前模板已注释，可随时恢复 */
.comment-left {
  flex-shrink: 0;
}

.avatar-wrap {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  position: relative;
}

.avatar-top1::before,
.avatar-top2::before,
.avatar-top3::before {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  z-index: 0;
  animation: spin-border 2s linear infinite;
}
.avatar-top1::before {
  background: conic-gradient(#FFD700, #ff9500, #FFD700, #fff8dc, #FFD700);
}
.avatar-top2::before {
  background: conic-gradient(#C0C0C0, #ffffff, #909090, #e8e8e8, #C0C0C0);
}
.avatar-top3::before {
  background: conic-gradient(#CD7F32, #f0c080, #A0522D, #e8a86a, #CD7F32);
}

@keyframes spin-border {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.comment-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  position: relative;
  z-index: 1;
  /* 白色间隙 */
  box-shadow: 0 0 0 3px #fff;
}

/* 右侧主体 */
.comment-body {
  flex: 1;
  min-width: 0;
}

/* 用户信息行：左侧名字+时间，右侧点赞 */
.comment-user-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.comment-user-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.comment-name {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 时间样式保留，当前模板已注释，可随时恢复 */
.comment-time {
  font-size: 22px;
  color: #bbb;
  line-height: 1;
}

.comment-likes {
  font-size: 26px;
  color: #ff6034;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 16px;
  padding-top: 4px;
}

.comment-text {
  font-size: 26px;
  color: #666;
  line-height: 1.6;
  word-break: break-all;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.comment-text--expanded {
  display: block;
  overflow: visible;
  line-clamp: unset;
  -webkit-line-clamp: unset;
}

.comment-expand {
  margin-top: 8px;
  font-size: 24px;
  color: #c471a0;
  cursor: pointer;
}
</style>
